var d="undefined"!=typeof window?window:{};export{d as global};
//# sourceMappingURL=global.js.map
